module.exports = __webpack_public_path__ + "img/modal-footer.ce3e4e54.png";